import React from "react";
import { Layout, Menu } from "antd";
import { useHistory } from "react-router-dom";

const { Sider } = Layout;

export default function Sidebar() {
  const history = useHistory();
  const handleClick = (e) => {
    if (e.key === "dashboard") {
      history.push("/dashboard");
      return;
    }
    history.push(`/dashboard/${e.key}`);
    return;
  };

  return (
    <Sider id="sidebar">
      <img
        className="sidebar_logo"
        alt="Carenting Logo"
        src={process.env.PUBLIC_URL + "/asset/logo.png"}
        style={{
          width: "140px",
        }}
      />
      <Menu mode="inline" className="menu" onClick={handleClick}>
        <Menu.Item
          key="dashboard"
          className={
            history.location.pathname === "/dashboard" ? "item active" : "item"
          }
        >
          Dashboard
        </Menu.Item>
        <Menu.Item
          key="article"
          className={
            history.location.pathname === "/dashboard/article"
              ? "item active"
              : "item"
          }
        >
          Article
        </Menu.Item>
        <Menu.Item
          key="plan"
          className={
            history.location.pathname === "/dashboard/plan"
              ? "item active"
              : "item"
          }
        >
          Plan Upgrade
        </Menu.Item>
        <Menu.Item
          key="psikolog"
          className={
            history.location.pathname === "/dashboard/psikolog"
              ? "item active"
              : "item"
          }
        >
          Registration
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
